const getAddressRows = (size, config) => config[size];
const parseAddress = (addressRows, addressData) => {
  const replacements = Object.entries(addressData).map(([key, value]) => ({
    regExp: new RegExp(`{${key}}`, "g"),
    value
  }));
  const inject = (row, replacements2) => replacements2.reduce(
    (acc, { regExp, value }) => value === void 0 ? acc : acc.replace(regExp, String(value)),
    row
  );
  const clean = (row) => {
    const unusedTemplateRegExp = new RegExp(/{([^}]+)}/, "g");
    return row.trim().replace(unusedTemplateRegExp, "").split(",").map((el) => el.trim()).filter((el) => !!el).join(", ");
  };
  return addressRows.map((row) => inject(row, replacements)).map(clean);
};
export {
  getAddressRows,
  parseAddress
};
//# sourceMappingURL=utils.js.map
